import React, { PropTypes } from 'react'

import './Avatar.scss'
import superaliadaBadge from './images/superaliadaBadge.png'
import defaultImage from './images/defaultImage.png'

export const getImage = image => image || defaultImage

const Avatar = (props) => {
  const {
    image,
    superaliada,
    size
  } = props

  const inlineStyle = {
    height: size,
    width: size
  }

  return (
    <div className='Avatar' style={inlineStyle}>
      <img
        className='Avatar-profilePicture'
        src={getImage(image)}
      />
      {superaliada &&
        <img
          className='Avatar-superaliadaBadge'
          title='Superaliada'
          src={superaliadaBadge} />
      }
    </div>
  )
}
Avatar.displayName = 'Avatar'
Avatar.propTypes = {
  image: PropTypes.string,
  size: PropTypes.number,
  superaliada: PropTypes.bool
}
Avatar.defaultProps = {
  image: defaultImage,
  superaliada: false,
  size: 66
}

export default Avatar



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/Avatar/Avatar.js